import React, { useEffect, useState } from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

// Import configs and util modules
import { intlShape, injectIntl, FormattedMessage } from '../../../../util/reactIntl';
import { propTypes } from '../../../../util/types';

// Import shared components
import { Button, Form, MediaUpload } from '../../../../components';
import arrayMutators from 'final-form-arrays';
// Import modules from this directory
import css from './EditListingTalentPlusPanel.module.css';
import CreateSubscriptionPriceModal from './CreateSubscriptionPriceModal';
import RenderUserSubscriptionMaybe from './RenderUserSubscriptionMaybe/RenderUserSubscriptionMaybe';
import { isArrayLength } from '../../../../util/genericHelpers';
import TalentPlusServices from '../EditListingMoreInfoPanel/TalentPlusServices/TalentPlusServices';

export const EditListingTalentPlusFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      const {
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        values,
        form,
        userType,
        subscriptionMaybe,
        lookupKeys,
        dirty,
        onLiveSubmit,
      } = formRenderProps;
      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const { updateListingError } = fetchErrors || {};

      const [isPlanModalOpen, setPlanModalOpen] = useState(false);
      const [selectedSubscription, setSelectedSubscription] = useState(false);

      useEffect(() => {
        if (dirty && !isPlanModalOpen) {
          const debounceTimer = setTimeout(async () => {
            try {
              await onLiveSubmit(values, form);
              console.log('Autosaved successfully!');
            } catch (error) {
              console.error('Autosave failed', error);
            }
          }, 1500); // 8 millisecond debounce

          // Cleanup to avoid multiple invocations during quick consecutive updates
          return () => clearTimeout(debounceTimer);
        }
      }, [dirty, values]);

      return (
        <Form onSubmit={handleSubmit} className={classes}>
          {updateListingError ? (
            <p className={css.error}>
              <FormattedMessage id="EditListingTalentPlusForm.updateFailed" />
            </p>
          ) : null}

          <div className={css.subcriptionPlanButton}>
            <Button type="button" onClick={() => setPlanModalOpen(!isPlanModalOpen)}>
              <FormattedMessage id="EditListingTalentPlusForm.createSubscriptionPlan" />
            </Button>
          </div>

          {isArrayLength(subscriptionMaybe) ? (
            <RenderUserSubscriptionMaybe
              subscriptions={subscriptionMaybe}
              lookupKeys={lookupKeys}
              onEdit={subscription => {
                setPlanModalOpen(true);
                setSelectedSubscription(subscription);
              }}
              isEditListingPage={true}
            />
          ) : null}

          <CreateSubscriptionPriceModal
            isOpen={isPlanModalOpen}
            onClose={() => setPlanModalOpen(false)}
            values={values}
            form={form}
            selectedSubscription={selectedSubscription}
            intl={intl}
            isTalentPlus={true}
          />

          <MediaUpload
            form={form}
            fieldName="profileVideos"
            acceptedTypes={{
              'video/mp4': [],
              'video/avi': [],
              'video/quicktime': [],
              'video/x-ms-wmv': [],
              'video/x-matroska': [],
              'video/x-flv': [],
              'video/webm': [],
              'video/mpeg': [],
              'video/mov': [],
            }}
            multiple={true}
            heading={intl.formatMessage({
              id: 'EditListingTalentPlusForm.profileVideosUploadHeading',
            })}
            description={intl.formatMessage({
              id: 'EditListingTalentPlusForm.profileVideosUploadDescription',
            })}
            values={values}
            userType={userType}
          />

          {/* <TalentPlusServices
            values={values.talentPlus || []}
            hideTitle={false}
            hideCustomOption={true}
            onLiveSave={onLiveSubmit ? newValues => onLiveSubmit(newValues, form) : undefined}
            viewport={window.innerWidth > 768 ? 'medium' : 'small'}
            availableServices={['Unlockable Content']} // Only show Unlockable Content
          /> */}

          <Button
            className={css.submitButton}
            type="button"
            inProgress={submitInProgress}
            ready={submitReady}
            onClick={() => onLiveSubmit(values, form)}
          >
            {saveActionMsg}
          </Button>
        </Form>
      );
    }}
  />
);

EditListingTalentPlusFormComponent.defaultProps = {
  fetchErrors: null,
  formId: 'EditListingTalentPlusForm',
};

EditListingTalentPlusFormComponent.propTypes = {
  formId: string,
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  updateInProgress: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
};

export default compose(injectIntl)(EditListingTalentPlusFormComponent);
